<template>
  <div
    class="
      text-90% text-white text-center
      font-bold
      rounded-full
      uppercase
      py-[0.8rem]
      transition-colors
      duration-300
    "
    :class="selected ? 'bg-blue' : 'bg-gray'"
    v-if="isLargeScreen"
  >
    {{ name }}
  </div>

  <h3 class="text-blue text-16 mb-0" v-else>{{ name }}</h3>
</template>

<script>
import { useMediaQuery } from '@vueuse/core'

export default {
  props: {
    name: {
      type: String,
      required: true,
    },
    selected: {
      type: Boolean,
      required: true,
    },
  },
  setup() {
    const isLargeScreen = useMediaQuery('(min-width: 1024px)')

    return {
      isLargeScreen,
    }
  },
}
</script>
